const prefix = 'drivex/customerMonthlyConsumptions';

const LOAD_MONTHLY_CONSUMPTION = `${prefix}/LOAD_MONTHLY_CONSUMPTION`;
const LOAD_MONTHLY_CONSUMPTION_SUCCESS = `${prefix}/LOAD_MONTHLY_CONSUMPTION_SUCCESS`;

export default {
  LOAD_MONTHLY_CONSUMPTION,
  LOAD_MONTHLY_CONSUMPTION_SUCCESS,
};
